import { render, staticRenderFns } from "./PosWhSetting.vue?vue&type=template&id=63f79dd8&scoped=true"
import script from "./PosWhSetting.vue?vue&type=script&lang=js"
export * from "./PosWhSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f79dd8",
  null
  
)

export default component.exports